import FirebaseService from './firebase.service';

class CajaService extends FirebaseService {
  constructor() {
    super('/caja');
  }

  async obtenerMovimientos({ fecha, sucursalId }) {
    const body = await this.get('/movimientos', { fecha, sucursalId });
    return this.ensureArray(body);
  }

  async obtenerResumen({ fecha, sucursalId }) {
    return this.get('/resumen', { fecha, sucursalId });
  }

  async obtenerMovimientosAcumulados({ sucursalId }) {
    const body = await this.get('/movimientos-acumulados', { sucursalId });
    return this.ensureArray(body);
  }

  async obtenerSaldoAcumulado({ sucursalId }) {
    return this.get('/saldo-acumulado', { sucursalId });
  }

  async verificarSaldoFisico({ sucursalId, saldoFisico }) {
    return this.post('/verificar-saldo', { saldoFisico }, { sucursalId });
  }

  async agregarMovimiento(payload, { sucursalId } = {}) {
    return this.post('/movimiento', payload, { sucursalId });
  }

  async eliminarMovimiento(id, { sucursalId, motivo } = {}) {
    return this.delete(`/movimiento/${id}`, { motivo }, { sucursalId });
  }

  async obtenerCierreDia({ fecha, sucursalId }) {
    return this.get('/cierre-dia', { fecha, sucursalId });
  }

  async registrarCierreDia({ fecha, sucursalId, efectivoDeclarado, observaciones, adminEmail, adminPassword }) {
    return this.post('/cierre-dia', {
      fecha,
      sucursalId,
      efectivoDeclarado,
      observaciones,
      adminEmail,
      adminPassword
    }, { sucursalId });
  }

  async corregirCierreDia(
    { fecha, sucursalId, efectivoDeclarado, observaciones, motivo, adminEmail, adminPassword },
    { sucursalId: sucursalQuery } = {}
  ) {
    return this.post('/cierre-dia/corregir', {
      fecha,
      sucursalId,
      efectivoDeclarado,
      observaciones,
      motivo,
      adminEmail,
      adminPassword
    }, { sucursalId: sucursalQuery || sucursalId });
  }

  async listarCierres({ sucursalId, fechaDesde, fechaHasta, limit = 50 } = {}) {
    return this.get('/cierres', { sucursalId, fechaDesde, fechaHasta, limit });
  }
}

export default new CajaService();
